/* eslint no-use-before-define: ["error", { "variables": false }] */

import React from "react";
import { Platform, StyleSheet, TextInput, View } from "react-native";
import Color from "@microdoing/shared/constants/Colors";
import theme from "app/Theme/Theme";

const MIN_COMPOSER_HEIGHT = Platform.select({
  ios: 33,
  android: 33, // 41
});
const DEFAULT_PLACEHOLDER = "Type a message...";

export default class Composer extends React.Component {
  onContentSizeChange(e) {
    const { contentSize } = e.nativeEvent;

    // Support earlier versions of React Native on Android.
    if (!contentSize) return;

    if (
      !this.contentSize ||
      this.contentSize.width !== contentSize.width ||
      this.contentSize.height !== contentSize.height
    ) {
      this.contentSize = contentSize;
      this.props.onInputSizeChanged(this.contentSize);
    }
  }

  onChangeText(text) {
    this.props.onTextChanged(text);
  }

  render() {
    return (
      <View style={[styles.inputContainer, this.props.inputContainerStyle]}>
        <TextInput
          testID={this.props.placeholder}
          accessible
          accessibilityLabel={this.props.placeholder}
          placeholder={this.props.placeholder}
          placeholderTextColor={this.props.placeholderTextColor}
          multiline={this.props.multiline}
          onChange={e => this.onContentSizeChange(e)}
          onContentSizeChange={e => this.onContentSizeChange(e)}
          onChangeText={text => this.onChangeText(text)}
          style={[
            styles.textInput,
            this.props.textInputStyle,
            { height: this.props.composerHeight },
            !this.props.text && Platform.OS !== "android" && { paddingTop: 8 },
          ]}
          autoFocus={this.props.textInputAutoFocus}
          // value={this.props.text}
          value={this.props.text}
          enablesReturnKeyAutomatically
          underlineColorAndroid="transparent"
          selectionColor={Color.defaultBlue}
          keyboardAppearance={this.props.keyboardAppearance}
          {...this.props.textInputProps}
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  inputContainer: {
    flex: 1,
    borderRadius: 20,
    marginRight: 12,
    marginLeft: 12,
    borderWidth: 1,
    borderColor: theme.colors["neutral.400"],
    backgroundColor: theme.colors["neutral.100"],
    alignItems: "flex-start",
    justifyContent: "center",
  },
  textInput: {
    outlineWidth: 0,
    color: theme.colors["neutral.900"],
    width: "100%",
    fontSize: 16,
    lineHeight: 16,
    textAlign: "left",
    textAlignVertical: "center",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: 10,
    marginRight: 10,
    paddingLeft: 5,
    paddingRight: 10,
    paddingTop: Platform.select({
      ios: 10,
      android: 0,
    }),
    marginTop: Platform.select({
      ios: 0,
      android: 0,
    }),
    marginBottom: Platform.select({
      ios: 0,
      android: 0,
    }),
  },
});

Composer.defaultProps = {
  composerHeight: MIN_COMPOSER_HEIGHT,
  text: "",
  placeholderTextColor: Color.defaultProps,
  placeholder: DEFAULT_PLACEHOLDER,
  textInputProps: null,
  multiline: true,
  textInputStyle: {},
  textInputAutoFocus: false,
  keyboardAppearance: "default",
  onTextChanged: () => {},
  onInputSizeChanged: () => {},
};
